import axios, { config } from '..';
import { GET_PAID_SUCCESS, GET_PAID_FAILED } from '../../actionTypes';

export default (body) => async (dispatch) => {
  try {
    const response = await axios.post(
      '/payouts/providers/get-paid',
      body,
      config
    );

    const {
      data: { message, data },
    } = response;
    dispatch({
      type: GET_PAID_SUCCESS,
      message,
      results: data,
    });
  } catch (err) {
    let error = {};
    if (err.response) {
      const {
        data: { status, message },
      } = err.response;
      error = { status, message };
    } else {
      error = {
        status: 500,
        message: err.message,
      };
    }
    dispatch({ type: GET_PAID_FAILED, error });
  }
};
